import { CheckList } from '@/components/common/CheckList';
import { PageSection } from '@/components/common/PageSection';
import { SectionHeading } from '@/components/common/SectionHeading';
import { Quality } from '@/pages/About/data';

const SectionId = 'quality';
const TitleId = 'quality-title';

export function QualitySection() {
  return (
    <PageSection id={SectionId} titleId={TitleId} tone="pad">
      <div className="grid gap-12 lg:grid-cols-12 lg:items-center lg:gap-16">
        <div className="lg:col-span-5">
          <SectionHeading id={TitleId} title={Quality.title} description={Quality.description} />
        </div>
        <div className="rounded-lg border border-grid bg-paper p-6 sm:p-8 lg:col-span-7">
          <h3 className="text-xl font-bold text-graphite">{Quality.checklistTitle}</h3>
          <CheckList items={Quality.checklist} className="mt-5" />
        </div>
      </div>
    </PageSection>
  );
}